// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as CardFields$OrcaPaymentPage from "../Components/CardFields.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as PaymentBody$OrcaPaymentPage from "../Utilities/PaymentBody.bs.js";
import * as PaymentHelpersV2$OrcaPaymentPage from "../Utilities/PaymentHelpersV2.bs.js";
import * as CardCollectorBridge$OrcaPaymentPage from "./CardCollectorBridge.bs.js";

function HyperswitchVaultCardCollector(props) {
  let cvcProps = props.cvcProps;
  let expiryProps = props.expiryProps;
  let cardProps = props.cardProps;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let themeObj = match.themeObj;
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let vaultCredentials = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.vaultCredentials);
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let setCvcError = cvcProps.setCvcError;
  let cvcNumber = cvcProps.cvcNumber;
  let isCVCValid = cvcProps.isCVCValid;
  let setExpiryError = expiryProps.setExpiryError;
  let cardExpiry = expiryProps.cardExpiry;
  let isExpiryValid = expiryProps.isExpiryValid;
  let cardBrand = cardProps.cardBrand;
  let setCardError = cardProps.setCardError;
  let cardNumber = cardProps.cardNumber;
  let isCardSupported = cardProps.isCardSupported;
  let isCardValid = cardProps.isCardValid;
  let parentURL = match$1.parentURL;
  let complete = Utils$OrcaPaymentPage.isAllValid(isCardValid, isCardSupported, isCVCValid, isExpiryValid, true, "payment");
  let empty = cardNumber === "" || cardExpiry === "" || cvcNumber === "";
  CardCollectorBridge$OrcaPaymentPage.useEmitCardState(cardNumber, cardExpiry, cvcNumber, cardBrand, complete, empty, isCardValid, isExpiryValid, isCVCValid, undefined, undefined, undefined, undefined, undefined);
  let reportCardFieldErrors = () => CardCollectorBridge$OrcaPaymentPage.reportValidationErrors(cardNumber, cardExpiry, cvcNumber, cardBrand, isCardSupported, complete, setCardError, setExpiryError, setCvcError, localeString);
  let handleSaveCard = async () => {
    Utils$OrcaPaymentPage.messageParentWindow(parentURL, [
      [
        "fullscreen",
        true
      ],
      [
        "param",
        "paymentloader"
      ]
    ]);
    let match;
    if (typeof vaultCredentials !== "object" || vaultCredentials.TAG !== "HyperswitchVault") {
      match = [
        "",
        ""
      ];
    } else {
      let credentials = vaultCredentials._0;
      match = [
        credentials.pmSessionId,
        credentials.sdkAuthorization
      ];
    }
    let match$1 = CardUtils$OrcaPaymentPage.getExpiryDates(cardExpiry);
    try {
      let response = await PaymentHelpersV2$OrcaPaymentPage.savePaymentMethod(PaymentBody$OrcaPaymentPage.cardTokenizationBody(cardNumber, match$1[0], match$1[1], cvcNumber), match[0], match[1], loggerState);
      return Utils$OrcaPaymentPage.messageParentWindow(parentURL, [
        [
          "cardTokenEvent",
          true
        ],
        [
          "vaultResponse",
          response
        ]
      ]);
    } catch (raw_error) {
      let error = Primitive_exceptions.internalToException(raw_error);
      Utils$OrcaPaymentPage.messageParentWindow(parentURL, [[
          "cardTokenFail",
          true
        ]]);
      console.error("Unable to Save Card ", JSON.stringify(Utils$OrcaPaymentPage.formatException(error)));
      return;
    }
  };
  let submitCallback = React.useCallback(ev => {
    let json = Utils$OrcaPaymentPage.safeParse(ev.data);
    let confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
    let isOuterValid = Utils$OrcaPaymentPage.getBool(Utils$OrcaPaymentPage.getDictFromJson(json), "isOuterValid", true);
    if (confirm.doSubmit) {
      if (complete && isOuterValid) {
        handleSaveCard();
        return;
      } else {
        return reportCardFieldErrors();
      }
    }
  }, [
    cardNumber,
    cardExpiry,
    cvcNumber,
    cardBrand,
    complete,
    vaultCredentials,
    loggerState,
    localeString
  ]);
  Utils$OrcaPaymentPage.useSubmitPaymentDataFromParent(parentURL, submitCallback);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(CardFields$OrcaPaymentPage.make, {
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps
        }),
        className: "flex flex-col w-full",
        style: {
          gridGap: themeObj.spacingGridColumn
        }
      }),
      className: "flex flex-col",
      style: {
        gridGap: themeObj.spacingGridColumn
      }
    }),
    className: "animate-slowShow"
  });
}

let make = HyperswitchVaultCardCollector;

export {
  make,
}
/* jotai Not a pure module */
